// extracted by mini-css-extract-plugin
export default {"radios":"ComplaintFormUserData-eJDQd__radios","userData":"ComplaintFormUserData-eVdMP__userData"};